import React from 'react'

import { Button, Card, CardContent, Typography, Menu, MenuItem } from '@material-ui/core'
import SimCardIcon from '@material-ui/icons/SimCard'

import useSelectedTariffCardStyles from './SelectedTariffCardStyles'

import useTariffCard from '../../hooks/useTariffCard'
import MainPriceOfCard from '../MainPriceOfCard/MainPriceOfCard'
import TariffPriceAndDuration from '../TariffPriceAndDuration/TariffPriceAndDuration'

import { Price } from '~/basket/model/common/price.model'
import BundlesModal from '~/bundles/components/BundlesModal/BundlesModal'
import { BundleType } from '~/bundles/model/bundles.model'

export interface SelectedTariffCard {
  id: string
  title: string
  minutes: number
  data: number
  prices: Price[]
  resetTariff: () => void
  className?: string
}

export default function SelectedTariffCard({
  id,
  title = '',
  minutes = 0,
  data = 0,
  prices = [],
  resetTariff,
  className,
}: SelectedTariffCard): React.ReactElement {
  const classes = useSelectedTariffCardStyles()
  const [mainPrice, ...restPrices] = prices

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const { formattedMinutes, formattedBytes } = useTariffCard({ data, minutes })

  return (
    <>
      <Card
        className={`${className} ${classes.cardContainer}`}
        data-hook={`selected-tariff-card-${id}`}
      >
        <div className={classes.iconContainer}>
          <SimCardIcon className={classes.icon} />
        </div>
        <CardContent className={classes.content}>
          <div className={classes.contentInfo}>
            <Typography className={classes.title} variant="subtitle1">
              {title}
            </Typography>
            <div className={classes.contentTariffDetail}>
              <div className={classes.info}>
                <Typography component="p" variant="body2" color="textSecondary">
                  minutos
                </Typography>
                <Typography component="p" variant="subtitle1">
                  {formattedMinutes}
                </Typography>
              </div>
              <div className={classes.info}>
                <Typography component="p" variant="body2" color="textSecondary">
                  datos
                </Typography>
                <Typography component="p" variant="subtitle1">
                  {formattedBytes}
                </Typography>
              </div>
            </div>
          </div>
          <div className={classes.pricesFlexContainer}>
            <div className={classes.pricesContainer}>
              <MainPriceOfCard price={mainPrice} isOnlyPrice={!restPrices.length} />
              {restPrices.map((price) => (
                <TariffPriceAndDuration
                  className={classes.secondPrice}
                  key={`selected-tariff-card-price-${price.value}`}
                  price={price}
                />
              ))}
            </div>
          </div>
          <Button
            color="secondary"
            size="small"
            variant="outlined"
            className={classes.button}
            onClick={handleClick}
          >
            Opciones
          </Button>
          <Menu
            elevation={5}
            getContentAnchorEl={null}
            id="customized-menu"
            anchorEl={anchorEl}
            keepMounted
            className={classes.menu}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            <MenuItem
              onClick={() => {
                resetTariff()
                handleClose()
              }}
            >
              <Typography className="link">Cambiar tarifa</Typography>
            </MenuItem>
            <MenuItem onClick={handleClose} className={classes.border}>
              <BundlesModal id={id} type={BundleType.PROMOS} />
            </MenuItem>
            <MenuItem onClick={handleClose}>
              <BundlesModal id={id} type={BundleType.BONUS} />
            </MenuItem>
          </Menu>
        </CardContent>
      </Card>
    </>
  )
}
